'use client';

import { useEffect } from 'react';
import { datadogLogs } from '@datadog/browser-logs';

const DatadogLogs: React.FC = () => {
  useEffect(() => {
    if (process.env.DATADOG_CLIENT_TOKEN) {
      datadogLogs.init({
        clientToken: process.env.DATADOG_CLIENT_TOKEN,
        version: process.env.NEXT_PUBLIC_APP_VERSION,
        site: 'datadoghq.com',
        service: 'interstitial-client-next',
        forwardErrorsToLogs: false,
        // console.logs will not be automatically forwarded to Datadog Logs
        // instead, we will use datadogLogs.logger to explicitly log messages
        // to Datadog
        forwardConsoleLogs: [],
        sessionSampleRate: process.env.DEPLOYABLE_ENV === 'prod' ? 0 : 100,
        env: process.env.DEPLOYABLE_ENV,
      });
    }
  }, []);

  return null;
};

export { datadogLogs };

export default DatadogLogs;
